import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import moment from "moment";
import { FaCheck, FaCircle, FaExclamation, FaTimes } from "react-icons/fa";
import { isMetaProperty } from "typescript";
import { GRAY, VARIANT, WHITE } from "../../../../constants/colors";
import { dateForListWithHours } from "../../../../constants/dataFormat";

interface StatusTypes {
  [chave: string]: JSX.Element;
}

export default function ModalPaymentDetail({ isOpen, setIsOpen, item }: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const historico = item;
  // console.log("item no modal", item);

  const statusTypes: StatusTypes = {
    "Efetivado": <FaCheck />,
    "Processando": <FaExclamation />,
    "Pendente": <FaExclamation />,
    "Remessa Gerada": <FaExclamation />,
    "Não efetivado": <FaExclamation />,
    "Cancelado": <FaTimes />,
  }

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Detalhes da Solicitação de Pagamento
              </Text>
            </Flex>
          </ModalHeader>
          {item && (
            <ModalBody>
              <Flex
                w={"530px"}
                alignItems={"flex-start"}
                minHeight={"250px"}
                height={"fit-content"}
                border={"2px solid #c4c4c4"}
                justifyContent={"space-evenly"}
                shadow={"md"}
                borderRadius={"6px"}
              >
                <TableContainer w={"100%"}>
                  <Table variant={"striped"} w={"100%"}>
                    <Thead>
                      <Tr>
                        <Th bgColor={VARIANT} color={WHITE}>
                          Data
                        </Th>
                        <Th bgColor={VARIANT} color={WHITE}>
                          Status
                        </Th>
                        <Th bgColor={VARIANT} color={WHITE}>
                          Observação
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {item.map((i: any) => {
                        return (
                          <Tr key={i.id}>
                            <Td fontSize={"14px"}>
                              {moment(i.criadoEm ? i.criadoEm : null).format(
                                dateForListWithHours
                              )}
                            </Td>
                            <Td fontSize={"14px"}>
                              {i.status ? 
                                (
                                  statusTypes.hasOwnProperty(i.status.status) ? 
                                    <Flex alignItems={"center"} justifyContent="flex-start">
                                      {statusTypes[i.status.status]} 
                                      <Flex ml={4}>{i.status.status}</Flex>
                                    </Flex>
                                    : 
                                    i.status.status
                                ) 
                                : 
                                ""
                              }
                            </Td>
                            <Td fontSize={"14px"}>
                              {i.observacao ? i.observacao : null}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            </ModalBody>
          )}
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
